import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const SPMObservationLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    spmDashboard: LazyLoadedStates,
    spmDashboardView: LazyLoadedStates,
    spmDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.spm',
        url: '/spm',
        abstract: true 
    },
    spmDashboard: {
        name: 'authenticated.user-summary.spm.dashboard',
        url: '/dashboard/:userId/:observationId',
        abstract: true,
    },
    spmDashboardView: {
        name: 'authenticated.user-summary.spm.dashboard.view',
        url: '/view'
    },
    spmDetails: {
        name: 'authenticated.user-summary.spm.details',
        url: '/details/:userId/:observationId/?:tabIndex',
    }
},
() => import('src/app/observations/spm/spm.module')
      .then((result: { SpmModule: any }) => result.SpmModule));